var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _g, _g2, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZoomerangCallStation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 154,
    viewBox: "0 0 192 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.669 136.316L150.619 149.699V151C150.619 152.009 149.817 152.836 148.808 152.866L133.851 153.319C131.391 153.394 128.964 152.737 126.876 151.433L108.547 139.977C108.001 139.636 107.669 139.038 107.669 138.394V136.316Z",
    fill: "#1A1A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.636 135.071C125.817 135.071 127.96 135.644 129.85 136.733L149.548 148.081C151.204 149.035 150.527 151.566 148.616 151.566H134.094C131.872 151.566 129.691 150.972 127.776 149.844L108.593 138.548C106.954 137.583 107.639 135.071 109.541 135.071H123.636Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131.154 31.5186H127.074V143.439H131.154V31.5186Z",
    fill: "#4D4D4D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M129.072 73.124H126.733L126.053 76.9868H132.173L131.561 73.124H129.072Z",
    fill: "#4D4D4D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M131.711 76.9873H126.516V93.7711H131.711V76.9873Z",
    fill: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M126.774 96.872H131.439C131.752 96.872 132.01 96.6136 132.01 96.3007C132.01 95.9879 131.752 95.7295 131.439 95.7295H126.774C126.461 95.7295 126.203 95.9879 126.203 96.3007C126.216 96.6136 126.461 96.872 126.774 96.872Z",
    fill: "#333333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M131.154 143.438C131.154 143.765 130.243 144.023 129.114 144.023C127.985 144.023 127.074 143.765 127.074 143.438C127.074 143.112 127.985 142.854 129.114 142.854C130.243 142.854 131.154 143.126 131.154 143.438Z",
    fill: "#4D4D4D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.4164 1.31692C62.9038 0.204598 64.2007 -0.301985 65.313 0.185438L123.723 25.7808C128.397 27.8291 132.852 29.7236 137.018 32.6707L191.039 65.2783C192.03 65.9796 192.266 67.3518 191.564 68.3433C190.863 69.3348 189.491 69.57 188.499 68.8688L134.479 36.2611C130.555 33.4858 126.36 31.7379 121.958 29.8089L63.5479 4.21352C62.4356 3.7261 61.929 2.42925 62.4164 1.31692Z",
    fill: "#333333"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.994 39.521C143.229 39.1911 143.687 39.114 144.016 39.3487L182.131 62.7341C182.461 62.9688 182.538 63.4264 182.303 63.7562C182.069 64.0861 181.611 64.1632 181.281 63.9285L143.166 40.5431C142.837 40.3085 142.76 39.8508 142.994 39.521Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3559 5.71199C70.5191 5.34156 70.9518 5.17359 71.3222 5.33684L114.568 24.3942C114.938 24.5574 115.106 24.9901 114.943 25.3605C114.78 25.7309 114.347 25.8989 113.977 25.7357L70.731 6.67831C70.3606 6.51506 70.1926 6.08243 70.3559 5.71199Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M138.807 43.5166L122.345 35.5963C117.704 33.3635 112.548 37.509 113.732 42.5209C114.228 44.622 115.648 46.3859 117.595 47.3194L134.967 55.6501C138.404 57.2985 142.454 55.1342 142.993 51.3602C143.457 48.1127 141.763 44.9389 138.807 43.5166Z",
    fill: "url(#paint0_linear_2_13514)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M137.833 44.7571L120.194 35.9723C117.297 34.5296 113.895 36.6365 113.895 39.8725V41.2454C113.895 43.6356 115.263 45.8148 117.417 46.8526L135.033 55.3435C137.926 56.7378 141.282 54.6299 141.282 51.4184V50.3288C141.282 47.9676 139.946 45.8097 137.833 44.7571Z",
    fill: "url(#paint1_linear_2_13514)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M125.406 40.7626C123.86 41.2929 123.35 43.8878 124.266 46.5656C125.182 49.2434 127.178 50.983 128.724 50.4566C130.27 49.9263 130.78 47.3314 129.864 44.6536C128.948 41.9758 126.952 40.2362 125.406 40.7626Z",
    fill: "url(#paint2_linear_2_13514)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M128.722 50.456C128.722 50.456 128.77 50.4409 128.858 50.4089C128.944 50.3723 129.074 50.3157 129.218 50.2085C129.362 50.1052 129.522 49.956 129.676 49.7602C129.829 49.5644 129.965 49.3157 130.074 49.0291C130.294 48.4559 130.406 47.7385 130.376 46.9725C130.349 46.2072 130.191 45.3998 129.932 44.6298C129.798 44.2461 129.638 43.8695 129.457 43.5136C129.276 43.1576 129.072 42.8176 128.845 42.5061C128.623 42.1953 128.378 41.9131 128.125 41.6745C127.873 41.4318 127.609 41.228 127.349 41.0699C127.089 40.908 126.827 40.799 126.584 40.735C126.342 40.671 126.124 40.6528 125.946 40.6589C125.769 40.6611 125.63 40.6995 125.539 40.7228C125.448 40.75 125.403 40.7699 125.403 40.7699C125.403 40.7699 125.45 40.7587 125.542 40.7315C125.636 40.713 125.772 40.6864 125.948 40.6921C126.124 40.6939 126.337 40.7192 126.569 40.7935C126.802 40.8639 127.049 40.9824 127.301 41.1468C127.808 41.4684 128.304 41.9766 128.734 42.591C128.949 42.8963 129.151 43.2316 129.324 43.582C129.501 43.9372 129.655 44.3043 129.782 44.6825C130.044 45.4406 130.205 46.2323 130.234 46.9816C130.268 47.7279 130.186 48.4389 129.985 49.0033C129.885 49.2835 129.761 49.5346 129.62 49.7327C129.482 49.9316 129.328 50.0863 129.193 50.1911C129.056 50.2999 128.933 50.366 128.846 50.4066C128.767 50.4361 128.722 50.456 128.722 50.456Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M125.403 46.1761C125.995 47.907 127.261 49.0554 128.282 48.8163C128.246 48.8298 128.214 48.8481 128.175 48.857C127.14 49.2123 125.8 48.0453 125.187 46.2488C124.574 44.4562 124.916 42.7117 125.952 42.3563C125.987 42.3428 126.026 42.3339 126.061 42.3243C125.112 42.7624 124.81 44.4451 125.403 46.1761Z",
    fill: "#A6A6A6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M128.942 44.9695C129.534 46.7005 129.236 48.3839 128.284 48.8173C127.264 49.0564 125.997 47.912 125.405 46.1771C124.813 44.4461 125.111 42.7627 126.063 42.3293C127.079 42.0894 128.35 43.2346 128.942 44.9695Z",
    fill: "url(#paint3_linear_2_13514)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M125.982 45.9828C126.426 47.2779 127.375 48.1379 128.137 47.959C128.11 47.9702 128.083 47.9813 128.057 47.9885C127.282 48.2553 126.283 47.3811 125.823 46.0379C125.364 44.6947 125.62 43.3932 126.395 43.1265C126.422 43.1153 126.448 43.1081 126.478 43.1017C125.761 43.4252 125.539 44.6838 125.982 45.9828Z",
    fill: "url(#paint4_linear_2_13514)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M128.629 45.0768C129.073 46.3718 128.851 47.6305 128.137 47.9586C127.375 48.1376 126.426 47.2815 125.982 45.9824C125.538 44.6874 125.761 43.4287 126.474 43.1006C127.237 42.9216 128.186 43.7777 128.629 45.0768Z",
    fill: "url(#paint5_linear_2_13514)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M126.363 45.8508C126.67 46.7535 127.33 47.3473 127.86 47.2213C127.842 47.2301 127.824 47.2389 127.807 47.2437C127.269 47.4297 126.571 46.8202 126.253 45.8868C125.935 44.9534 126.113 44.0475 126.651 43.8615C126.668 43.8567 126.69 43.8487 126.708 43.8439C126.211 44.0749 126.055 44.9482 126.363 45.8508Z",
    fill: "url(#paint6_linear_2_13514)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M128.204 45.2227C128.512 46.1253 128.357 46.9987 127.86 47.2257C127.33 47.3517 126.671 46.7539 126.363 45.8552C126.055 44.9526 126.21 44.0792 126.707 43.8522C127.238 43.7223 127.897 44.3201 128.204 45.2227Z",
    fill: "url(#paint7_linear_2_13514)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M126.793 45.7008C126.947 46.1501 127.275 46.4447 127.538 46.3853C127.529 46.3877 127.52 46.394 127.511 46.3964C127.242 46.4875 126.895 46.1851 126.739 45.7231C126.58 45.2604 126.668 44.8094 126.937 44.7144C126.946 44.712 126.955 44.7096 126.963 44.7072C126.72 44.8195 126.643 45.2522 126.793 45.7008Z",
    fill: "url(#paint8_linear_2_13514)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M127.708 45.3876C127.863 45.837 127.786 46.2697 127.537 46.3852C127.274 46.4485 126.947 46.15 126.792 45.7007C126.638 45.2514 126.715 44.8187 126.964 44.7032C127.23 44.6445 127.558 44.9391 127.708 45.3876Z",
    fill: "url(#paint9_linear_2_13514)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M126.984 45.0035C126.843 45.0498 126.797 45.2872 126.88 45.5336C126.963 45.78 127.124 44.9572 126.984 45.0035Z",
    fill: "url(#paint10_linear_2_13514)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M127.57 46.1172C127.653 46.0884 127.681 45.946 127.633 45.7968C127.583 45.6515 127.486 46.1459 127.57 46.1172Z",
    fill: "url(#paint11_linear_2_13514)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M125 46.3143C124.387 44.5218 124.919 42.7118 125.954 42.3604C125.989 42.3468 126.028 42.338 126.063 42.3284C127.083 42.0893 128.35 43.2337 128.942 44.9686C129.534 46.6996 129.236 48.383 128.284 48.8164C128.249 48.8299 128.217 48.8482 128.178 48.8571C127.139 49.2117 125.613 48.1109 125 46.3143Z",
    fill: "url(#paint12_linear_2_13514)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.609 46.2175C122.609 46.3894 122.469 46.5287 122.298 46.5287C122.126 46.5287 121.986 46.3894 121.986 46.2175C121.986 46.0456 122.126 45.9062 122.298 45.9062C122.469 45.9062 122.609 46.0456 122.609 46.2175Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.364 45.5954C121.364 45.7673 121.224 45.9066 121.052 45.9066C120.881 45.9066 120.741 45.7673 120.741 45.5954C120.741 45.4235 120.881 45.2842 121.052 45.2842C121.224 45.2842 121.364 45.4235 121.364 45.5954Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.119 44.9724C120.119 45.1442 119.98 45.2836 119.808 45.2836C119.636 45.2836 119.497 45.1442 119.497 44.9724C119.497 44.8005 119.636 44.6611 119.808 44.6611C119.98 44.6611 120.119 44.8005 120.119 44.9724Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.874 44.3503C118.874 44.5222 118.735 44.6615 118.563 44.6615C118.391 44.6615 118.251 44.5222 118.251 44.3503C118.251 44.1784 118.391 44.0391 118.563 44.0391C118.735 44.0391 118.874 44.1784 118.874 44.3503Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.609 44.9724C122.609 45.1442 122.469 45.2836 122.298 45.2836C122.126 45.2836 121.986 45.1442 121.986 44.9724C121.986 44.8005 122.126 44.6611 122.298 44.6611C122.469 44.6611 122.609 44.8005 122.609 44.9724Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.364 44.3503C121.364 44.5222 121.224 44.6615 121.052 44.6615C120.881 44.6615 120.741 44.5222 120.741 44.3503C120.741 44.1784 120.881 44.0391 121.052 44.0391C121.224 44.0391 121.364 44.1784 121.364 44.3503Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.119 43.7282C120.119 43.9001 119.98 44.0394 119.808 44.0394C119.636 44.0394 119.497 43.9001 119.497 43.7282C119.497 43.5563 119.636 43.417 119.808 43.417C119.98 43.417 120.119 43.5563 120.119 43.7282Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.874 43.1052C118.874 43.2771 118.735 43.4164 118.563 43.4164C118.391 43.4164 118.251 43.2771 118.251 43.1052C118.251 42.9333 118.391 42.7939 118.563 42.7939C118.735 42.7939 118.874 42.9333 118.874 43.1052Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.609 43.7282C122.609 43.9001 122.469 44.0394 122.298 44.0394C122.126 44.0394 121.986 43.9001 121.986 43.7282C121.986 43.5563 122.126 43.417 122.298 43.417C122.469 43.417 122.609 43.5563 122.609 43.7282Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.364 43.1052C121.364 43.2771 121.224 43.4164 121.052 43.4164C120.881 43.4164 120.741 43.2771 120.741 43.1052C120.741 42.9333 120.881 42.7939 121.052 42.7939C121.224 42.7939 121.364 42.9333 121.364 43.1052Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.119 42.4831C120.119 42.655 119.98 42.7943 119.808 42.7943C119.636 42.7943 119.497 42.655 119.497 42.4831C119.497 42.3112 119.636 42.1719 119.808 42.1719C119.98 42.1719 120.119 42.3112 120.119 42.4831Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.874 41.8601C118.874 42.0319 118.735 42.1713 118.563 42.1713C118.391 42.1713 118.251 42.0319 118.251 41.8601C118.251 41.6882 118.391 41.5488 118.563 41.5488C118.735 41.5488 118.874 41.6882 118.874 41.8601Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.609 42.4831C122.609 42.655 122.469 42.7943 122.298 42.7943C122.126 42.7943 121.986 42.655 121.986 42.4831C121.986 42.3112 122.126 42.1719 122.298 42.1719C122.469 42.1719 122.609 42.3112 122.609 42.4831Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.364 41.8601C121.364 42.0319 121.224 42.1713 121.052 42.1713C120.881 42.1713 120.741 42.0319 120.741 41.8601C120.741 41.6882 120.881 41.5488 121.052 41.5488C121.224 41.5488 121.364 41.6882 121.364 41.8601Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.119 41.238C120.119 41.4099 119.98 41.5492 119.808 41.5492C119.636 41.5492 119.497 41.4099 119.497 41.238C119.497 41.0661 119.636 40.9268 119.808 40.9268C119.98 40.9268 120.119 41.0661 120.119 41.238Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.874 40.6159C118.874 40.7878 118.735 40.9271 118.563 40.9271C118.391 40.9271 118.251 40.7878 118.251 40.6159C118.251 40.444 118.391 40.3047 118.563 40.3047C118.735 40.3047 118.874 40.444 118.874 40.6159Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.609 41.238C122.609 41.4099 122.469 41.5492 122.298 41.5492C122.126 41.5492 121.986 41.4099 121.986 41.238C121.986 41.0661 122.126 40.9268 122.298 40.9268C122.469 40.9268 122.609 41.0661 122.609 41.238Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.364 40.6159C121.364 40.7878 121.224 40.9271 121.052 40.9271C120.881 40.9271 120.741 40.7878 120.741 40.6159C120.741 40.444 120.881 40.3047 121.052 40.3047C121.224 40.3047 121.364 40.444 121.364 40.6159Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.119 39.9929C120.119 40.1648 119.98 40.3041 119.808 40.3041C119.636 40.3041 119.497 40.1648 119.497 39.9929C119.497 39.821 119.636 39.6816 119.808 39.6816C119.98 39.6816 120.119 39.821 120.119 39.9929Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.874 39.3708C118.874 39.5427 118.735 39.682 118.563 39.682C118.391 39.682 118.251 39.5427 118.251 39.3708C118.251 39.1989 118.391 39.0596 118.563 39.0596C118.735 39.0596 118.874 39.1989 118.874 39.3708Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.609 39.9929C122.609 40.1648 122.469 40.3041 122.298 40.3041C122.126 40.3041 121.986 40.1648 121.986 39.9929C121.986 39.821 122.126 39.6816 122.298 39.6816C122.469 39.6816 122.609 39.821 122.609 39.9929Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.364 39.3708C121.364 39.5427 121.224 39.682 121.052 39.682C120.881 39.682 120.741 39.5427 120.741 39.3708C120.741 39.1989 120.881 39.0596 121.052 39.0596C121.224 39.0596 121.364 39.1989 121.364 39.3708Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.119 38.7477C120.119 38.9196 119.98 39.059 119.808 39.059C119.636 39.059 119.497 38.9196 119.497 38.7477C119.497 38.5759 119.636 38.4365 119.808 38.4365C119.98 38.4365 120.119 38.5759 120.119 38.7477Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.874 38.1257C118.874 38.2976 118.735 38.4369 118.563 38.4369C118.391 38.4369 118.251 38.2976 118.251 38.1257C118.251 37.9538 118.391 37.8145 118.563 37.8145C118.735 37.8145 118.874 37.9538 118.874 38.1257Z",
    fill: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.303 53.0642C136.303 53.236 136.163 53.3754 135.991 53.3754C135.82 53.3754 135.68 53.236 135.68 53.0642C135.68 52.8923 135.82 52.7529 135.991 52.7529C136.163 52.7529 136.303 52.8923 136.303 53.0642Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.058 52.4421C135.058 52.614 134.918 52.7533 134.746 52.7533C134.574 52.7533 134.435 52.614 134.435 52.4421C134.435 52.2702 134.574 52.1309 134.746 52.1309C134.918 52.1309 135.058 52.2702 135.058 52.4421Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.813 51.819C133.813 51.9909 133.674 52.1303 133.502 52.1303C133.33 52.1303 133.19 51.9909 133.19 51.819C133.19 51.6472 133.33 51.5078 133.502 51.5078C133.674 51.5078 133.813 51.6472 133.813 51.819Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.568 51.197C132.568 51.3689 132.428 51.5082 132.257 51.5082C132.085 51.5082 131.945 51.3689 131.945 51.197C131.945 51.0251 132.085 50.8857 132.257 50.8857C132.428 50.8857 132.568 51.0251 132.568 51.197Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.303 51.819C136.303 51.9909 136.163 52.1303 135.991 52.1303C135.82 52.1303 135.68 51.9909 135.68 51.819C135.68 51.6472 135.82 51.5078 135.991 51.5078C136.163 51.5078 136.303 51.6472 136.303 51.819Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.058 51.197C135.058 51.3689 134.918 51.5082 134.746 51.5082C134.574 51.5082 134.435 51.3689 134.435 51.197C134.435 51.0251 134.574 50.8857 134.746 50.8857C134.918 50.8857 135.058 51.0251 135.058 51.197Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.813 50.5739C133.813 50.7458 133.674 50.8851 133.502 50.8851C133.33 50.8851 133.19 50.7458 133.19 50.5739C133.19 50.402 133.33 50.2627 133.502 50.2627C133.674 50.2627 133.813 50.402 133.813 50.5739Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.568 49.9519C132.568 50.1237 132.428 50.2631 132.257 50.2631C132.085 50.2631 131.945 50.1237 131.945 49.9519C131.945 49.78 132.085 49.6406 132.257 49.6406C132.428 49.6406 132.568 49.78 132.568 49.9519Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.303 50.5739C136.303 50.7458 136.163 50.8851 135.991 50.8851C135.82 50.8851 135.68 50.7458 135.68 50.5739C135.68 50.402 135.82 50.2627 135.991 50.2627C136.163 50.2627 136.303 50.402 136.303 50.5739Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.058 49.9519C135.058 50.1237 134.918 50.2631 134.746 50.2631C134.574 50.2631 134.435 50.1237 134.435 49.9519C134.435 49.78 134.574 49.6406 134.746 49.6406C134.918 49.6406 135.058 49.78 135.058 49.9519Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.813 49.3298C133.813 49.5017 133.674 49.641 133.502 49.641C133.33 49.641 133.19 49.5017 133.19 49.3298C133.19 49.1579 133.33 49.0186 133.502 49.0186C133.674 49.0186 133.813 49.1579 133.813 49.3298Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.568 48.7067C132.568 48.8786 132.428 49.018 132.257 49.018C132.085 49.018 131.945 48.8786 131.945 48.7067C131.945 48.5348 132.085 48.3955 132.257 48.3955C132.428 48.3955 132.568 48.5348 132.568 48.7067Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.303 49.3298C136.303 49.5017 136.163 49.641 135.991 49.641C135.82 49.641 135.68 49.5017 135.68 49.3298C135.68 49.1579 135.82 49.0186 135.991 49.0186C136.163 49.0186 136.303 49.1579 136.303 49.3298Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.058 48.7067C135.058 48.8786 134.918 49.018 134.746 49.018C134.574 49.018 134.435 48.8786 134.435 48.7067C134.435 48.5348 134.574 48.3955 134.746 48.3955C134.918 48.3955 135.058 48.5348 135.058 48.7067Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.813 48.0847C133.813 48.2565 133.674 48.3959 133.502 48.3959C133.33 48.3959 133.19 48.2565 133.19 48.0847C133.19 47.9128 133.33 47.7734 133.502 47.7734C133.674 47.7734 133.813 47.9128 133.813 48.0847Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.568 47.4626C132.568 47.6345 132.428 47.7738 132.257 47.7738C132.085 47.7738 131.945 47.6345 131.945 47.4626C131.945 47.2907 132.085 47.1514 132.257 47.1514C132.428 47.1514 132.568 47.2907 132.568 47.4626Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.303 48.0847C136.303 48.2565 136.163 48.3959 135.991 48.3959C135.82 48.3959 135.68 48.2565 135.68 48.0847C135.68 47.9128 135.82 47.7734 135.991 47.7734C136.163 47.7734 136.303 47.9128 136.303 48.0847Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.058 47.4626C135.058 47.6345 134.918 47.7738 134.746 47.7738C134.574 47.7738 134.435 47.6345 134.435 47.4626C134.435 47.2907 134.574 47.1514 134.746 47.1514C134.918 47.1514 135.058 47.2907 135.058 47.4626Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.813 46.8395C133.813 47.0114 133.674 47.1508 133.502 47.1508C133.33 47.1508 133.19 47.0114 133.19 46.8395C133.19 46.6677 133.33 46.5283 133.502 46.5283C133.674 46.5283 133.813 46.6677 133.813 46.8395Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.568 46.2175C132.568 46.3894 132.428 46.5287 132.257 46.5287C132.085 46.5287 131.945 46.3894 131.945 46.2175C131.945 46.0456 132.085 45.9062 132.257 45.9062C132.428 45.9062 132.568 46.0456 132.568 46.2175Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.303 46.8395C136.303 47.0114 136.163 47.1508 135.991 47.1508C135.82 47.1508 135.68 47.0114 135.68 46.8395C135.68 46.6677 135.82 46.5283 135.991 46.5283C136.163 46.5283 136.303 46.6677 136.303 46.8395Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.058 46.2175C135.058 46.3894 134.918 46.5287 134.746 46.5287C134.574 46.5287 134.435 46.3894 134.435 46.2175C134.435 46.0456 134.574 45.9062 134.746 45.9062C134.918 45.9062 135.058 46.0456 135.058 46.2175Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.813 45.5944C133.813 45.7663 133.674 45.9057 133.502 45.9057C133.33 45.9057 133.19 45.7663 133.19 45.5944C133.19 45.4225 133.33 45.2832 133.502 45.2832C133.674 45.2832 133.813 45.4225 133.813 45.5944Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.568 44.9724C132.568 45.1442 132.428 45.2836 132.257 45.2836C132.085 45.2836 131.945 45.1442 131.945 44.9724C131.945 44.8005 132.085 44.6611 132.257 44.6611C132.428 44.6611 132.568 44.8005 132.568 44.9724Z",
    fill: "black"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1498 149.523C70.2964 149.523 78.5218 146.292 78.5218 142.305C78.5218 138.319 70.2964 135.088 60.1498 135.088C50.0032 135.088 41.7778 138.319 41.7778 142.305C41.7778 146.292 50.0032 149.523 60.1498 149.523Z",
    fill: "#333333"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5187 142.319C78.5187 145.996 70.2928 148.986 60.1524 148.986C50.012 148.986 41.7861 146.004 41.7861 142.319V144.014C41.7861 147.69 50.012 150.681 60.1524 150.681C70.098 150.681 78.1968 147.809 78.5103 144.225H78.5187V142.319Z",
    fill: "#1A1A1A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9396 43.5811H58.3228V142.787H61.9396V43.5811Z",
    fill: "#4D4D4D"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0939 80.46H58.0203L57.4175 83.8839H62.8427L62.3002 80.46H60.0939Z",
    fill: "#4D4D4D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4336 83.8838H57.8281V98.7609H62.4336V83.8838Z",
    fill: "#333333"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0576 101.51H62.1928C62.4701 101.51 62.6992 101.281 62.6992 101.003C62.6992 100.726 62.4701 100.497 62.1928 100.497H58.0576C57.7803 100.497 57.5513 100.726 57.5513 101.003C57.5633 101.281 57.7803 101.51 58.0576 101.51Z",
    fill: "#333333"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9396 142.787C61.9396 143.076 61.1318 143.305 60.1312 143.305C59.1305 143.305 58.3228 143.076 58.3228 142.787C58.3228 142.498 59.1305 142.269 60.1312 142.269C61.1318 142.269 61.9396 142.51 61.9396 142.787Z",
    fill: "#4D4D4D"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.01056 16.8099C1.44261 15.8239 2.59214 15.3749 3.5781 15.807L55.3525 38.4946C59.4958 40.3102 63.4443 42.5412 67.1375 45.1535L115.021 79.0224C115.9 79.644 116.109 80.8604 115.487 81.7393C114.865 82.6181 113.649 82.8266 112.77 82.205L64.8864 48.3361C61.4083 45.876 57.6898 43.7749 53.7879 42.0651L2.01351 19.3774C1.02755 18.9454 0.578513 17.7959 1.01056 16.8099Z",
    fill: "#333333"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.4348 51.778C72.6429 51.4856 73.0485 51.4172 73.3409 51.6253L107.126 75.6644C107.418 75.8724 107.486 76.2781 107.278 76.5704C107.07 76.8628 106.665 76.9312 106.372 76.7232L72.5875 52.684C72.2952 52.476 72.2268 52.0703 72.4348 51.778Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.04898 20.7062C8.19368 20.3779 8.57717 20.229 8.90552 20.3737L47.2382 37.2661C47.5666 37.4108 47.7154 37.7942 47.5707 38.1226C47.426 38.4509 47.0426 38.5998 46.7142 38.4551L8.38152 21.5628C8.05317 21.4181 7.90429 21.0346 8.04898 20.7062Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1225 49.7324H44.377L54.1225 54.2804V67.9242L60.6196 64.6757V52.3312L54.1225 49.7324Z",
    fill: "url(#paint13_linear_2_13514)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3479 53.3267L44.6395 49.4847C44.21 49.2952 43.7275 49.6097 43.7275 50.0791V62.0736C43.7275 62.5469 43.9849 62.9828 44.3995 63.2114L53.1594 68.0423C53.5924 68.281 54.1228 67.9678 54.1228 67.4733V54.5155C54.1228 54.0007 53.8189 53.5345 53.3479 53.3267Z",
    fill: "#4D4D4D"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0781 50.0792C43.0781 49.1404 44.0431 48.5114 44.902 48.8903L53.6105 52.7323C54.317 53.044 54.7728 53.7434 54.7728 54.5156V67.4734C54.7728 68.4624 53.712 69.0888 52.8459 68.6112L44.086 63.7804C43.4642 63.4375 43.0781 62.7836 43.0781 62.0736V50.0792ZM53.086 53.9211L44.3775 50.0792V62.0736C44.3775 62.3103 44.5062 62.5282 44.7135 62.6425L53.4734 67.4734V54.5156C53.4734 54.2582 53.3215 54.025 53.086 53.9211Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5588 54.1754C49.0683 53.6577 51.0161 55.3599 51.9104 57.9741C52.8047 60.5884 52.3064 63.1256 50.7976 63.6394C50.3374 63.7977 50.6211 63.701 50.1609 63.8593C48.6514 64.377 46.7035 62.6748 45.8092 60.0606C44.9149 57.4464 45.4133 54.9091 46.922 54.3953C47.383 54.2332 47.0947 54.3329 47.5588 54.1754Z",
    fill: "url(#paint14_linear_2_13514)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9192 54.3908C45.4097 54.9085 44.9121 57.4419 45.8064 60.0561C46.7007 62.6703 48.6493 64.3686 50.158 63.8548C51.6675 63.3371 52.1651 60.8037 51.2708 58.1895C50.3765 55.5752 48.4279 53.8769 46.9192 54.3908Z",
    fill: "url(#paint15_linear_2_13514)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1564 63.8547C50.1564 63.8547 50.2034 63.8399 50.2898 63.8087C50.373 63.7729 50.5002 63.7177 50.6411 63.613C50.7812 63.5122 50.9382 63.3665 51.088 63.1754C51.2379 62.9842 51.3698 62.7414 51.4769 62.4616C51.6911 61.9021 51.8006 61.2016 51.771 60.4538C51.7452 59.7068 51.5912 58.9185 51.3378 58.1668C51.2069 57.7921 51.0504 57.4245 50.874 57.077C50.6976 56.7295 50.4981 56.3975 50.2771 56.0934C50.0599 55.79 49.8213 55.5145 49.5742 55.2815C49.328 55.0447 49.0703 54.8456 48.8158 54.6914C48.5621 54.5332 48.3062 54.4268 48.0698 54.3644C47.8334 54.3019 47.6204 54.2841 47.4467 54.2901C47.2738 54.2922 47.1381 54.3297 47.0494 54.3524C46.96 54.379 46.9161 54.3984 46.9161 54.3984C46.9161 54.3984 46.9623 54.3875 47.0518 54.3609C47.1436 54.3429 47.277 54.3169 47.4484 54.3225C47.6205 54.3242 47.8282 54.349 48.0546 54.4215C48.2818 54.4902 48.5237 54.6059 48.769 54.7664C49.2648 55.0804 49.7489 55.5765 50.1686 56.1764C50.3788 56.4743 50.5752 56.8017 50.7446 57.1438C50.9171 57.4906 51.0673 57.8489 51.1913 58.2182C51.4471 58.9583 51.6041 59.7312 51.6328 60.4628C51.6662 61.1913 51.586 61.8855 51.3896 62.4365C51.2917 62.71 51.1714 62.9551 51.0331 63.1486C50.8987 63.3427 50.7487 63.4938 50.6163 63.5961C50.4832 63.7023 50.3622 63.7668 50.2782 63.8064C50.2003 63.8353 50.1564 63.8547 50.1564 63.8547Z",
    fill: "#A6A6A6"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9156 59.6757C47.4941 61.3656 48.7299 62.4867 49.7263 62.2532C49.6916 62.2665 49.66 62.2843 49.6222 62.2929C48.6115 62.6399 47.3032 61.5005 46.7051 59.7466C46.1063 57.9966 46.4409 56.2935 47.4515 55.9466C47.4862 55.9334 47.524 55.9247 47.558 55.9154C46.6317 56.3431 46.3371 57.9858 46.9156 59.6757Z",
    fill: "#A6A6A6"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3711 58.4981C50.9496 60.188 50.6589 61.8315 49.7295 62.2546C48.7331 62.4881 47.4966 61.3708 46.9188 59.6771C46.3403 57.9872 46.631 56.3437 47.5604 55.9206C48.553 55.6864 49.7933 56.8044 50.3711 58.4981Z",
    fill: "url(#paint16_linear_2_13514)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4812 59.4868C47.9147 60.7512 48.8407 61.5908 49.5849 61.4161C49.5587 61.427 49.5325 61.4379 49.5071 61.445C48.75 61.7054 47.7745 60.852 47.3262 59.5406C46.8779 58.2293 47.1274 56.9587 47.8845 56.6983C47.9107 56.6874 47.9362 56.6804 47.9655 56.6741C47.2657 56.9899 47.0484 58.2186 47.4812 59.4868Z",
    fill: "url(#paint17_linear_2_13514)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0659 58.602C50.4994 59.8664 50.2821 61.0951 49.5854 61.4155C48.8412 61.5902 47.9144 60.7544 47.4817 59.4862C47.0482 58.2219 47.2655 56.9931 47.9621 56.6727C48.7064 56.498 49.6331 57.3338 50.0659 58.602Z",
    fill: "url(#paint18_linear_2_13514)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8535 59.3589C48.1537 60.2401 48.7978 60.8198 49.3153 60.6969C49.2976 60.7054 49.2799 60.714 49.2629 60.7187C48.7379 60.9003 48.0566 60.3053 47.7463 59.394C47.436 58.4828 47.6097 57.5984 48.1347 57.4168C48.1516 57.4121 48.1732 57.4043 48.1902 57.3996C47.7047 57.6251 47.5533 58.4777 47.8535 59.3589Z",
    fill: "url(#paint19_linear_2_13514)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6503 58.7449C49.9505 59.6261 49.799 60.4788 49.3143 60.7004C48.7968 60.8234 48.1534 60.2398 47.8524 59.3624C47.5522 58.4813 47.7037 57.6286 48.1884 57.407C48.7066 57.2802 49.3501 57.8638 49.6503 58.7449Z",
    fill: "url(#paint20_linear_2_13514)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2736 59.2134C48.4241 59.652 48.7446 59.9396 49.0007 59.8816C48.9922 59.8839 48.983 59.8901 48.9745 59.8925C48.7124 59.9814 48.3733 59.6862 48.2212 59.2352C48.0653 58.7834 48.1518 58.3431 48.4146 58.2504C48.4231 58.248 48.4316 58.2457 48.4401 58.2434C48.202 58.353 48.127 58.7755 48.2736 59.2134Z",
    fill: "url(#paint21_linear_2_13514)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1676 58.9071C49.3181 59.3458 49.2432 59.7682 49.0004 59.881C48.7436 59.9429 48.4238 59.6514 48.2734 59.2128C48.1229 58.7741 48.1978 58.3517 48.4406 58.2389C48.7005 58.1817 49.021 58.4692 49.1676 58.9071Z",
    fill: "url(#paint22_linear_2_13514)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4595 58.5313C48.3223 58.5765 48.2768 58.8082 48.3579 59.0488C48.439 59.2893 48.5968 58.486 48.4595 58.5313Z",
    fill: "url(#paint23_linear_2_13514)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0318 59.6185C49.1136 59.5905 49.1409 59.4515 49.0933 59.3057C49.0449 59.1639 48.9501 59.6466 49.0318 59.6185Z",
    fill: "url(#paint24_linear_2_13514)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M46.5231 59.8117C45.9243 58.0617 46.4438 56.2947 47.4538 55.9516C47.4884 55.9383 47.5262 55.9297 47.5602 55.9203C48.5566 55.6869 49.7931 56.8041 50.3708 58.4979C50.9494 60.1878 50.6586 61.8313 49.7292 62.2543C49.6946 62.2676 49.663 62.2854 49.6252 62.2941C48.6106 62.6403 47.1211 61.5656 46.5231 59.8117Z",
    fill: "url(#paint25_linear_2_13514)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6196 53.3834C60.6196 52.7479 60.2327 52.1765 59.6427 51.9405L54.1226 49.7324H56.4709C57.4958 49.7324 58.5124 49.9168 59.472 50.2766L62.2101 51.3034C62.8166 51.5309 63.2184 52.1107 63.2184 52.7585V61.9495C63.2184 62.4387 62.9881 62.8993 62.5968 63.1928L60.6196 64.6757V53.3834Z",
    fill: "#303030"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_13514",
    x1: 114.953,
    y1: 37.4403,
    x2: 141.998,
    y2: 52.7396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44484A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242627"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_13514",
    x1: 113.895,
    y1: 38.115,
    x2: 141.23,
    y2: 53.6071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696C6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292C2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_13514",
    x1: 128.724,
    y1: 50.4565,
    x2: 125.408,
    y2: 40.7643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_13514",
    x1: 126.062,
    y1: 42.3295,
    x2: 128.281,
    y2: 48.8171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6D7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30333D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_13514",
    x1: 125.731,
    y1: 43.3509,
    x2: 127.395,
    y2: 48.2136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30333D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A6D7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2_13514",
    x1: 126.475,
    y1: 43.1009,
    x2: 128.136,
    y2: 47.9551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6D7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30333D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2_13514",
    x1: 126.188,
    y1: 44.0222,
    x2: 127.345,
    y2: 47.4022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30333D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A6D7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2_13514",
    x1: 126.706,
    y1: 43.8491,
    x2: 127.86,
    y2: 47.2233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6D7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30333D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2_13514",
    x1: 126.708,
    y1: 44.7916,
    x2: 127.284,
    y2: 46.4732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30333D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A6D7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2_13514",
    x1: 126.965,
    y1: 44.7052,
    x2: 127.539,
    y2: 46.3839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16171C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2_13514",
    x1: 126.987,
    y1: 45.2975,
    x2: 126.797,
    y2: 45.2602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2_13514",
    x1: 127.678,
    y1: 45.9614,
    x2: 127.563,
    y2: 45.9389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2288,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5084,
    stopColor: "#6B6B6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7393,
    stopColor: "#313131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9093,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2_13514",
    x1: 125.858,
    y1: 42.392,
    x2: 128.082,
    y2: 48.8909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101114"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2_13514",
    x1: 52.8231,
    y1: 51.0318,
    x2: 54.7723,
    y2: 64.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B5B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24742,
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D3D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2_13514",
    x1: 50.4766,
    y1: 63.7455,
    x2: 47.2391,
    y2: 54.2832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#393939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9732,
    stopColor: "#A0A0A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2_13514",
    x1: 50.158,
    y1: 63.8546,
    x2: 46.9206,
    y2: 54.3925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787878"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2_13514",
    x1: 47.5597,
    y1: 55.9209,
    x2: 49.7267,
    y2: 62.2544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6D7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30333D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2_13514",
    x1: 47.2362,
    y1: 56.9174,
    x2: 48.8605,
    y2: 61.6647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30333D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A6D7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2_13514",
    x1: 47.9625,
    y1: 56.6731,
    x2: 49.584,
    y2: 61.4121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6D7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30333D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2_13514",
    x1: 47.6831,
    y1: 57.5737,
    x2: 48.8121,
    y2: 60.8735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30333D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A6D7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2_13514",
    x1: 48.1873,
    y1: 57.4039,
    x2: 49.3144,
    y2: 60.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A6D7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30333D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2_13514",
    x1: 48.1909,
    y1: 58.3258,
    x2: 48.7526,
    y2: 59.9675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30333D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A6D7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2_13514",
    x1: 48.4416,
    y1: 58.2409,
    x2: 49.0023,
    y2: 59.8798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16171C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2_13514",
    x1: 48.4627,
    y1: 58.8183,
    x2: 48.2771,
    y2: 58.7819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2_13514",
    x1: 49.1373,
    y1: 59.4665,
    x2: 49.0253,
    y2: 59.4445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2288,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5084,
    stopColor: "#6B6B6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7393,
    stopColor: "#313131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9093,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2_13514",
    x1: 47.3606,
    y1: 55.9825,
    x2: 49.5314,
    y2: 62.3271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101114"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomerangCallStation);
export default __webpack_public_path__ + "static/media/ZoomerangCallStation.d0e82ba46fcfb07c3730963bade59409.svg";
export { ForwardRef as ReactComponent };